export function normalizePdfFileName(displayName: string | null | undefined): string {
  let name = (displayName ?? '').replace(/[<>:"/\\|?*\u0000-\u001f]/g, '_').trim().replace(/[. ]+$/, '');
  if (!name) return 'document.pdf';
  // Windows reserves these names even when followed by an extension.
  if (/^(con|prn|aux|nul|com[1-9¹²³]|lpt[1-9¹²³])(?:\.|$)/i.test(name)) name = `_${name}`;
  return /\.pdf$/i.test(name) ? name : `${name}.pdf`;
}
